var map = {
	"./customerList.json": [
		604,
		604
	],
	"./fetchMenuType.json": [
		5387,
		387
	],
	"./fetchMenuTypeList.json": [
		3604,
		984
	],
	"./fetchOrderList.json": [
		902,
		902
	],
	"./fetchReadyOrders.json": [
		8138,
		138
	],
	"./fetchTableList.json": [
		6896,
		896
	],
	"./meals.json": [
		6584,
		584
	],
	"./menuType/1.json": [
		6710,
		710
	],
	"./menuType/2.json": [
		6554,
		554
	],
	"./menuType/3.json": [
		928,
		928
	],
	"./menuType/list.json": [
		8584,
		203
	],
	"./old/list.json": [
		4500,
		500
	],
	"./old/menu.json": [
		1392,
		392
	],
	"./old/orderList.json": [
		2986,
		986
	],
	"./old/tableList.json": [
		5980,
		980
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5428;
module.exports = webpackAsyncContext;